const installationInstructions = {
  intro: {
    currentStep: 'intro',
    includeInstallationSteps: false,
    includePairingProcess: true,
    isLastPage: false,
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
    // prevStep: N/A
    prevStepName: 'https://return-to-app',
    primaryText: 'Congratulations on getting a PowerTech Switch!',
    resource: require('@/assets/device-models/PTS-01/pep-smart-switch.png'),
    resourceType: 'image',
    secondaryText: "To get your device up and running we'll guide you through the ",
    continueButtonText: 'Get Started',
  },
  letsGetStarted: {
    additionalSecondaryTextClasses: 'section-seperator',
    // alternateNextStep: N/A,
    continueButtonText: 'Get Started',
    currentStep: 'letsGetStarted',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    // nextStep: N/A
    // nextStepName: N/A,
    // prevStep: N/A,
    prevStepName: 'installationIntro', // installationIntro doesn't have a prop of :step so omit `prevStep`
    primaryText: "Let's Get Started",
    // resource: N/A,
    // resourceType: N/A,
    secondaryText: 'To pair your PowerTech Switch, you need the following:',
    steps: [
      {
        icon: require('@/assets/images/wifi-icon.png'),
        description: 'Strong Wi-Fi Network & Password'
      },
      {
        icon: require('@/assets/images/power-outlet-icon.png'),
        description: 'Power Source'
      }
    ],
    title: 'Pair Switch'
  },
  pairingModeReset: {
    prevStep: 'letsGetStarted',
    headerIcon: 'arrowGrey',
    prevStepName: 'instructions',
    currentStep: 'pairingModeReset',
    resourceType: 'image',
    resource: require('@/assets/device-models/PTS-01/pep-smart-switch.png'),
    primaryText: 'Putting the PowerTech Switch into Pairing Mode',
    secondaryText: 'If the LED is not double blinking green, the switch is not in pairing mode. To manually put the switch into pairing mode:',
    steps: [
      {
        title: 'Press and hold the button at the ',
        description: 'bottom of the switch.',
        stepNumber: 1
      },
      {
        title: 'Release the button after 5 seconds.',
        stepNumber: 2
      },
      {
        title: 'After the PowerTech switch finishes ',
        description: 'restarting, the LED on the front of the switch will turn to double blinking green.',
        stepNumber: 3
      },
    ],
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    title: 'Re-Pair Switch'
  }
};

export default installationInstructions;
